export default function tabbedCards() {
  return {
    activeTab: 0,
    activeAccordion: -1,
    tabIds: {},
    
    init() {
      // Set up keyboard navigation for desktop tabs
      this.$el.addEventListener('keydown', (e) => {
        if (e.target.role !== 'tab') return;

        let newIndex = this.activeTab;
        const tabCount = this.$el.querySelectorAll('[role="tab"]').length;

        switch(e.key) {
          case 'ArrowDown':
          case 'ArrowRight':
            e.preventDefault();
            newIndex = (this.activeTab + 1) % tabCount;
            break;
          case 'ArrowUp':
          case 'ArrowLeft':
            e.preventDefault();
            newIndex = (this.activeTab - 1 + tabCount) % tabCount;
            break;
          case 'Home':
            e.preventDefault();
            newIndex = 0;
            break;
          case 'End':
            e.preventDefault();
            newIndex = tabCount - 1;
            break;
        }

        if (newIndex !== this.activeTab) {
          this.activeTab = newIndex;
          this.$nextTick(() => {
            const buttonId = this.tabIds[newIndex]?.button;
            if (buttonId) {
              this.$el.querySelector(`#${buttonId}`)?.focus();
            }
          });
        }
      });
    }
  };
}